/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILobasCategoryImageViewProps } from './lobas-category-image';
import { IImageData, IImageSettings, Image } from '@msdyn365-commerce/core';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node, INodeProps } from '@msdyn365-commerce-modules/utilities';

const _getCategoryImage = (props: ILobasCategoryImageViewProps): React.ReactNode | null => {
    const categoryImage = props.image;

    if (!categoryImage || !categoryImage.src) {
        return null;
    }

    const categoryImageUrl = generateImageUrl(`${categoryImage.src}`, props.context.actionContext.requestContext.apiSettings);
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: 'w=300&h=250&m=8', w: 0, h: 0 },
            sm: { q: 'w=300&h=250&m=8', w: 0, h: 0 },
            md: { q: 'w=600&h=550&m=8', w: 0, h: 0 },
            lg: { q: 'w=600&h=550&m=8', w: 0, h: 0 }
        },
        lazyload: false,
        disableLazyLoad: true
    };
    if (categoryImageUrl !== undefined) {
        const imageData: IImageData = { src: categoryImageUrl };
        return (
            <Image
                requestContext={props.context.actionContext.requestContext}
                className='ms-nav-image__item'
                {...imageData}
                gridSettings={props.context.request.gridSettings!}
                imageSettings={categoryImage.imageSettings ?? props.config.categoryImageSettings ?? defaultImageSettings}
                loadFailureBehavior='hide'
                role='tabpanel'
                id='categoryImageTag__categoryImage'
                altText={categoryImage.altText}
            />
        );
    }
    return null;
};

const LobasCategoryImageView: React.FC<ILobasCategoryImageViewProps> = props => {
    const ImageDivContainer: INodeProps = {
        tag: 'div',
        className: 'category-image',
        role: 'tabpanel'
    };

    return (
        <Module className={props.config.className ?? ''} moduleProps={props}>
            {props.image && (
                // eslint-disable-next-line react/jsx-key
                <Node {...ImageDivContainer} className={ImageDivContainer.className}>
                    {_getCategoryImage(props)}
                </Node>
            )}
        </Module>
    );
};

export default LobasCategoryImageView;
